<div class="item" (click)="_onClick()">
    <div class="icon">
        <i class="fa-solid fa-heart"></i>
    </div>
    <!--<div class="text">  
        <span>Meus <br>Favoritos</span>
    </div>-->   
</div> 
